import { render, staticRenderFns } from "./appointmentsreports.vue?vue&type=template&id=12cbb382"
import script from "./appointmentsreports.vue?vue&type=script&lang=js"
export * from "./appointmentsreports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports